<template>
  <div>
        <modal :modal-key="'welcome_modal'" :class-style="'modal modal--welcomeback modal--ranking'"
               :body-style="'welcone_pad'"
               @close="$emit('close')">
          <template slot="header">
          <h1>{{ getTranslations.home_modals_ranking_type }}</h1>
          <p>{{ getTranslations.home_modals_ranking_date }}</p>
          <img class="usericon" src="static/images/prize.png" alt="">
          </template>
          <template slot="body">
          <p class="ranking_prize">[{{ getTranslations.home_modals_ranking_prize }}]</p>
          <p>{{ getTranslations.home_modals_ranking_rank }}: {{ getShowmodalForRanking.userLevel }}</p>
          <p>{{ getTranslations.home_modals_ranking_points }}: {{ getShowmodalForRanking.gamesEarned }}</p>
          </template>
      </modal>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  name: 'ranking',
  components: {
    Modal,
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getShowmodalForRanking',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/Ranking.vue